// removed by extract-text-webpack-plugin
module.exports = {"SuggestTagDialog":"_1ukDI1E65nNLh8P8bK5ZcB","SuggestTagDialog--error":"_3FUF5fV9XC3YfqKB5KPcuQ","jiggle":"_2-LFqW_cKg1NiQM2R8gxtW","SuggestTagDialog__inner":"_23OQw1S33Ltj3p5TSVYjUm","SuggestTagDialog__question":"_2q4lPBEX9zJsAG9fpPOEmA","SuggestTagDialog__textarea":"_32tWhC0yQZWzydvjXv4uBW","SuggestTagDialog__buttons":"_2dhtWjba_wUeyAdsAzBJbt","SuggestTagDialog__button":"_37UF8m53zXdCsDjKoxELxt","SuggestTagDialog__loading-indicator":"_273i_FZoyMsLAp-usM94bH","SuggestTagDialog__success-message":"_3HwbXEKjaF9FbTymd7K_ve"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SuggestTagDialog/SuggestTagDialog.scss
// module id = 2711
// module chunks = 0